import { createAction, props } from '@ngrx/store';
import { ProxyUserRequest, ProxyUserRequestDuplicate, ProxyUserRequestResponse } from '../../models/proxy-user-request';

export const submitProxyUserRequest = createAction(
  '[Proxy Access] Submit Proxy User Request',
  props<{ request: ProxyUserRequest }>()
);

export const submitProxyUserRequestSuccess = createAction(
  '[Proxy Access] Submit Proxy User Request Success',
  props<{ response: ProxyUserRequestResponse }>()
);

export const submitProxyUserRequestFailure = createAction(
  '[Proxy Access] Submit Proxy User Request Failure',
  props<{ error: unknown }>()
);

/**
 * AC6: the API rejected this authorization because an identical one is already pending, and told us
 * which request is on file. Deliberately not a `...Failure`: nothing went wrong and there is nothing
 * to retry, so the form surfaces the existing request's reference number and status instead of the
 * generic retryable error.
 */
export const submitProxyUserRequestDuplicate = createAction(
  '[Proxy Access] Submit Proxy User Request Duplicate',
  props<{ duplicate: ProxyUserRequestDuplicate }>()
);

/**
 * Clears a completed submission so a second authorization starts from a blank slate. Without it the
 * form would see the previous `isSubmitted` and bounce straight to the confirmation page.
 */
export const resetProxyUserRequest = createAction('[Proxy Access] Reset Proxy User Request');
